import { brandCyanRgba, brandRgba } from '../../config/brandColors';
import { SIDEBAR_THEME } from './sidebarTheme';

export const SYSTEM_FINDER_PLACEHOLDER = 'Encontre pacientes ou funções do sistema';

/** Barra global — faixa azul bem suave; texto no cinza padrão do sistema. */
export const globalSystemFinderBarSx = {
  '& .MuiOutlinedInput-root': {
    borderRadius: 0,
    height: 32,
    fontSize: '0.8125rem',
    background: `linear-gradient(135deg, ${brandCyanRgba(0.14)} 0%, ${brandRgba(0.1)} 55%, ${SIDEBAR_THEME.muted} 100%)`,
    color: SIDEBAR_THEME.slateMid,
    transition: 'background 0.15s ease, box-shadow 0.15s ease',
    boxShadow: 'none',
    '& fieldset': { border: 'none' },
    '&:hover': {
      background: `linear-gradient(135deg, ${brandCyanRgba(0.18)} 0%, ${brandRgba(0.12)} 55%, ${SIDEBAR_THEME.muted} 100%)`,
    },
    '&.Mui-focused': {
      background: `linear-gradient(135deg, ${brandCyanRgba(0.2)} 0%, ${brandRgba(0.14)} 55%, ${SIDEBAR_THEME.paper} 100%)`,
      boxShadow: `inset 0 -1px 0 0 ${SIDEBAR_THEME.borderSoft}`,
    },
  },
  '& .MuiInputBase-input': {
    cursor: 'text',
    color: SIDEBAR_THEME.slateMid,
    py: 0,
    '&::placeholder': {
      color: SIDEBAR_THEME.slate,
      opacity: 1,
    },
  },
} as const;
